import dayjs from 'dayjs';
import { billingPolicyIntervals } from '../constants';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';

/**
 * 次回お届け日を作成
 * @param subscription
 */
export const createSummary = (subscription: SubscriptionApiType) => {
  // 決済周期
  const billingPolicyInterval = `${subscription.billingPolicyIntervalCount}${
    billingPolicyIntervals[subscription.billingPolicyInterval]
  }`;

  // 次回お届け予定時間
  const matchDeliveryTime =
    subscription.shop.deliveryTimes.find((time) => time.tag === subscription.deliveryTime) ?? null;

  // 直近の決済成功
  const recentOrder = subscription.billingAttempts.find(
    (attempt) => attempt.orderId !== null && attempt.ready
  );

  return {
    billingPolicyInterval,
    nextDeliveryDate: dayjs(subscription.nextDeliveryDate).toDate(),
    nextDeliveryTime: matchDeliveryTime?.tag ?? null,
    nextDeliveryTimeText: matchDeliveryTime?.title ?? '',
    nextBillingDate: subscription.nextBillingDate,
    recentOrderId: recentOrder?.orderId ?? '',
  };
};
